/* eslint-disable react/prop-types */
import * as React from 'react';

export const Send = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.4351 2.58198C20.9349 2.0686 20.1946 1.87734 19.5043 2.07866L3.40775 6.75952C2.67945 6.96186 2.16324 7.54269 2.02419 8.28055C1.88213 9.0315 2.37833 9.98479 3.0266 10.3834L8.05966 13.4768C8.57587 13.7939 9.24214 13.7144 9.66932 13.2835L15.4327 7.4843C15.7228 7.18231 16.203 7.18231 16.4931 7.4843C16.7832 7.77623 16.7832 8.24935 16.4931 8.55134L10.7197 14.3516C10.2916 14.7814 10.2115 15.4508 10.5267 15.9702L13.6019 21.0538C13.9621 21.6577 14.5823 22 15.2626 22C15.3426 22 15.4327 22 15.5127 21.9899C16.293 21.8893 16.9133 21.3558 17.1434 20.6008L21.9153 4.52479C22.1254 3.84028 21.9353 3.09537 21.4351 2.58198Z"
      fill={props.color || '#64748B'}
    />
  </svg>
);
